export const LastPageStore = {
  getLastPage: () => localStorage.getItem("last-page"),
  setLastPage: page => localStorage.setItem("last-page", page),
  removeLastPage: () => localStorage.removeItem("last-page")
};
